import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { AssetRequestComponent } from './asset-request/asset-request.component';
import { PublishAssetsComponent } from './publish-assets/publish-assets.component';

@Component({
  selector: 'app-access-requests-home',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    OrgAdminSidebarComponent,
    PageHeaderComponent,
    AssetRequestComponent,
    PublishAssetsComponent,
  ],
  templateUrl: './access-requests-home.component.html',
  styleUrl: './access-requests-home.component.scss',
})
export class AccessRequestsHomeComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  activeTab: string = 'assetRequest';

  ngOnInit(): void {
    // Read tab from query params to maintain state on refresh
    const tabFromUrl = this.route.snapshot.queryParamMap.get('tab');
    if (tabFromUrl === 'assetRequest' || tabFromUrl === 'publishAssets') {
      this.activeTab = tabFromUrl;
    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;

    // Update URL query param to maintain tab state on refresh
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }
}
